module.exports = __webpack_public_path__ + "static/media/il-no-reports@2x.28a48190.png";